import {MarkdownViewer} from '@github-ui/markdown-viewer'
import {useQuery} from '@github-ui/react-query'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {mintUnsafeStaticHTML} from '@github-ui/trusted-types/unsafe-static'
import {clsx} from 'clsx'
import type {Ref} from 'react'

import styles from './MarkdownEditor.module.css'
import {markdownPreviewQueryOptions} from './preview-query'

interface MarkdownEditorPreviewProps {
  markdown: string
  onRenderPreview: (markdown: string) => Promise<SafeHTMLString>
  ref?: Ref<HTMLDivElement>
  inputHeight: number
  teamHovercardsEnabled: boolean
  fullHeight: boolean | undefined
}

export function MarkdownEditorPreview({
  markdown,
  onRenderPreview,
  ref,
  inputHeight,
  teamHovercardsEnabled,
  fullHeight,
}: MarkdownEditorPreviewProps) {
  const previewQuery = useQuery(markdownPreviewQueryOptions(markdown, onRenderPreview))

  return (
    <div
      aria-live="polite"
      tabIndex={-1}
      ref={ref}
      className={clsx(styles.previewViewerWrapper, fullHeight && styles.fullHeight)}
      // Add 16px to match the margin around the edit-mode textarea so that there is no layout shift when switching modes
      style={{minHeight: inputHeight ? `calc(${inputHeight}px + 2 * var(--base-size-8))` : undefined}}
    >
      <h2 className={styles.previewHeader}>Rendered Markdown preview</h2>
      <MarkdownViewer
        verifiedHTML={previewQuery.data || mintUnsafeStaticHTML('Nothing to preview')}
        loading={previewQuery.isFetching}
        teamHovercardsEnabled={teamHovercardsEnabled}
        openLinksInNewTab
      />
    </div>
  )
}
